/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/adminNavigation.scss';

import React, {useContext, useEffect} from 'react';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import {AppContext} from '../../misc/appContext';
import classNames from 'classnames';
import {onSetCrumbs} from '../../../util/events';
import {sendGaPageView} from '../../../util/analytics';
import {onNavigate} from '../../../util/utils';
import {AdminContext} from '../../misc/adminContext';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import {ADMIN_DEFAULT_TEMPLATES_PATH, ADMIN_PLATFORM_USAGE_PATH, ADMIN_ROUTE} from '../../../util/constants';

export default function AdminNavigation() {
    const context = useContext(AppContext);
    const adminContext = useContext(AdminContext);
    const {user} = context.userContext;
    const isSuperAdmin = user?.isSuperAdmin() ?? false;

    function renderItem(label: string, icon: IconName, route: string) {
        return (
            <div className='navigation-item' onClick={onNavigate(`/admin/${route}`)}>
                <AwesomeIcon name={icon} className='nav-icon' />
                <label className='nav-label'>{label}</label>
            </div>
        );
    }

    useEffect(() => {
        sendGaPageView(ADMIN_ROUTE);
        onSetCrumbs([{label: 'Admin', route: ADMIN_ROUTE}]);
        adminContext.onChangeContext({user: null, account: null});
    }, []);

    return (
        <div className={classNames('admin-navigation', isSuperAdmin && 'super')}>
            {renderItem('Gebruikers', 'users', 'gebruikers')}
            {isSuperAdmin ? renderItem('Threads log', 'clipboard-list', 'threads') : <div />}
            {isSuperAdmin ? renderItem('Cron', 'server', 'services') : <div />}
            {isSuperAdmin ? renderItem('30 dagen import', 'history', 'historie-import') : <div />}
            {isSuperAdmin ? renderItem('E-mails verzenden', 'envelope', 'email-verzending') : <div />}
            {isSuperAdmin ? renderItem('Mislukte betalingen', 'euro-sign', 'mislukte-betalingen') : <div />}
            {isSuperAdmin ? renderItem('Standaard templates', 'envelope', ADMIN_DEFAULT_TEMPLATES_PATH) : <div />}
            {isSuperAdmin ? renderItem('Platformgebruik', 'chart-bar', ADMIN_PLATFORM_USAGE_PATH) : <div />}
        </div>
    );
}
